export default __webpack_public_path__ + "static/media/wheather-dashboard.2234911e.gif";